let resizeTimeout = null;
let isMobileView = $(window).width() <= 749; // Track current state
let originalSlides = [];
let videoSlides = [];

function showHideMainImagesByAlt(colorTitle){
  var $mainItems = $('.grid__item .product-single__media-wrapper');
  $mainItems.each(function () {
    var main_altText = $(this).attr("data-alt");
    if (main_altText === colorTitle || main_altText === 'Video') {
      $(this).removeClass('hide');
    } else {
      $(this).addClass('hide');
    }
  });
}

function updateMobileClass() {
  var $target = $('.product-single .product-single__media-group');
  var mobileClass = 'mobile_view';
  $target.addClass(mobileClass);
  $('.thumbnails-wrapper').addClass('hide');

  originalSlides = [];
  videoSlides = [];

  $('.grid__item .product-single__media-wrapper').each(function () {
    const $this = $(this);
    const alt = ($this.attr('data-alt') || '').toLowerCase();
    if (alt === 'video') {
      // videoSlides.push($this);
    } else {
      originalSlides.push($this);
    }
  });

  var imageColor = $('input[name="options_100116"]:checked');
  var colorTitle = imageColor.data('txt');
  showHideMainImagesByAlt(colorTitle);
  mainImagesByColor(colorTitle);
  reInitSlick();
}

function mainImagesByColor(colorTitle) {
  const matchedSlides = [];
  const lowerColor = (colorTitle || '').split(' ')[0].toLowerCase();

  // Transparent logic
  if (lowerColor === 'transparent') {
    originalSlides.forEach(function ($slide) {
      const altText = ($slide.attr('data-alt') || '').toLowerCase();
      if (
        altText === 'transparent' ||
        altText === 'transparent_one' ||
        altText === 'transparent_two' ||
        altText === 'transparent_three'
      ) {
        matchedSlides.push($slide);
      }
    });
  } else {
    // First image of selected color
    originalSlides.forEach(function ($slide) {
      const altText = ($slide.attr('data-alt') || '').split(' ')[0].toLowerCase();
      if (altText === lowerColor) {
        matchedSlides.push($slide);
        return false; // Only first match
      }
    });

    // Add transparent variants
    originalSlides.forEach(function ($slide) {
      const altText = ($slide.attr('data-alt') || '').toLowerCase();
      if (
        altText === 'transparent_one' ||
        altText === 'transparent_two' ||
        altText === 'transparent_three'
      ) {
        matchedSlides.push($slide);
      }
    });
  }

  // Always add video slides at the end
  matchedSlides.push(...videoSlides);
  updateSliders(matchedSlides);
}


function updateSliders(slideElements) {
  const $sliderWrapper = $('.product-single__media-group');
  if ($sliderWrapper.hasClass('slick-initialized')) {
    $sliderWrapper.slick('unslick');
  }
  $sliderWrapper.empty();

  slideElements.forEach(function ($slide, index) {
    const $clonedSlide = $slide
      .clone()
      .removeClass('slick-slide slick-cloned slick-current slick-active hide')
      .removeAttr('data-slick-index aria-hidden tabindex role aria-labelledby style');
    $clonedSlide.attr('data-slide-index', index + 1);
    $sliderWrapper.append($clonedSlide);
  });
}

function reInitSlick() {
  var $slider = $('.product-single .product-single__media-group');
  $slider.slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $slider.on('afterChange', function (event, slick, currentSlide) {
    $slider.find('video').each(function () {
      this.pause();
    });

    const $currentSlide = $(slick.$slides.get(currentSlide));
    const $video = $currentSlide.find('video');
    if ($video.length > 0) {
      const vid = $video.get(0);
      vid.setAttribute('controls', 'true');
      vid.load();
      vid.play();
    }
  });

  $slider.slick('slickGoTo', 0);
}

// Debounced resize handler
$(window).on('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    const currentWidth = $(window).width();
    const nowMobile = currentWidth <= 749;

    if (nowMobile !== isMobileView) {
      isMobileView = nowMobile;

      if (nowMobile) {
        updateMobileClass();
      } else {
        // Desktop: remove slider and reset
        const $target = $('.product-single__media-group');
        $target.removeClass('mobile_view');
        $('.thumbnails-wrapper').removeClass('hide');
        if ($target.hasClass('slick-initialized')) {
          $target.slick('unslick');
        }
      }
    }
  }, 250); // Run only after 250ms of no resize
});

// On first load (mobile)
if (isMobileView) {
  updateMobileClass();
}
